import React, { useEffect, useState } from 'react';
import classnames from "classnames";
import { Card, CardBody, CardHeader, Container, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import ViewsTab from 'Components/Common/Views/ViewsTab';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { ThunkDispatch } from '@reduxjs/toolkit';
import { Action } from 'redux';
import Source from './Sources';
import { sourcesMetadataGetRequest } from 'store/sources/action';
import BreadCrumb from 'Components/Common/BreadCrumb';
import SourcesTree from './SourcesTree';
import { useCompanyName } from 'Components/Common/ThemeSettings/themeutitlity';

const Universities = (props: any) => {    
    const metaData = useSelector((state: ApplicationState) => state.sources.metaDataFields);
    const dispatch: ThunkDispatch<any, null, Action<string>> = useDispatch();
    const [activeTab, setActiveTab] = useState('table')

    useEffect(() => {
        const filters = { pageSize: 500 }
        dispatch(sourcesMetadataGetRequest("sources", filters));
    }, [])
    
    document.title=`DTS | |  ${useCompanyName()}`;
    return (
        <React.Fragment>
            
            <div className="page-content">
                <Container fluid>  
                    <BreadCrumb title={props.t("Sources")} pageTitle={props.t("Sources")} icon={"ri-list-check"} />
                     <Card>
                <CardHeader>
                    <Nav
                        className="nav-custom-light rounded card-header-tabs nav-border-top"
                        role="tablist"
                    >
                        <NavItem>
                            <NavLink
                                className={classnames({
                                    active: activeTab === "table",
                                })}
                                onClick={() => {
                                    setActiveTab("table");
                                }}
                                href="#"				>
                                <strong>Table</strong>
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({
                                    active: activeTab === "visualize",
                                })}
                                onClick={() => {
                                    setActiveTab("visualize");
                                }}
                                href="#"				>
                                <strong>Visualize</strong>
                            </NavLink>
                        </NavItem>
                    </Nav>
                </CardHeader>
                <CardBody className="">
                    <TabContent activeTab={activeTab}>
                        {
                            activeTab === "table" && <TabPane tabId="table">
                                 <Row>
                        <ViewsTab 
                            component={Source}
                            metadata={metaData}
                            model={"sources"}
                            title={props.t("source.listing.breadcrumb.sources")} 
                        />
                    </Row>
                            </TabPane>
                        }
                        {
                            activeTab === "visualize" && <TabPane tabId="visualize">
                                <SourcesTree />
                            </TabPane>
                        }
                    </TabContent>
                </CardBody>
            </Card>                         
                   
                </Container>
            </div>
        </React.Fragment>
    );
};

export default withTranslation()(Universities);

